const entitlements = {
    ADVANCED_FILTERS: 'ADVANCED_FILTERS',
};

export default entitlements;